import {
  VersionHistory,
  VersionHistoryViewModel,
} from 'src/app/core/models/self-assessment/version-history';
import { GDPRService } from 'src/app/core/services/rulebook';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { SelfAssessment } from './../../../core/models/self-assessment/self-assessment';
import { VersionHistoryFilter } from 'src/app/core/models/self-assessment/version-history-filter';
import { VersionFilterViewModel } from 'src/app/core/models/self-assessment/version-filter-view-model';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { SelfAssessmentNew } from 'src/app/core/models/self-assessmentT2/self-assessmentT2';
import { VersionFilterViewT2Model } from 'src/app/core/models/self-assessmentT2/version-filter-viewT2-model';
import {
  VersionFilterViewT3Model,
  VersionHistoryT3,
  VersionHistoryT3ViewModel,
} from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SelfAssessmentTemplate3OverallAssessmentComponent } from '../../self-assessment-template3/self-assessment-template3-overall-assessment/self-assessment-template3-overall-assessment.component';
import { FrontComponent } from '../../self-assessment-template3/shared-components/front/front.component';
import { InterpretationsT3Component } from '../../self-assessment-template3/interpretations-t3/interpretations-t3.component';
import { JudgmentT3Component } from '../../self-assessment-template3/judgment-t3/judgment-t3.component';
import { ApproachT3Component } from '../../self-assessment-template3/approach-t3/approach-t3.component';

@Component({
  selector: 'app-self-assessment-dialog',
  templateUrl: './self-assessment-dialog.component.html',
  styleUrls: ['./self-assessment-dialog.component.scss'],
})
export class SelfAssessmentDialogComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  selfAssessment: SelfAssessment = new SelfAssessment();
  selfAssessmentT2: SelfAssessmentNew = new SelfAssessmentNew();
  versionHistory: VersionHistory[];
  versionHistoryFilter: VersionHistoryFilter;
  takeCount = 0;
  skipCount = 0;
  isLoading = false;
  myInnerHeight: any;
  endIndex = 0;
  totalCount = 0;
  templateNo = 0;

  constructor(
    private gdprService: GDPRService,
    private selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    public dialogRef: MatDialogRef<SelfAssessmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public resultViewData: VersionFilterViewModel,
    @Inject(MAT_DIALOG_DATA) public resultViewDataT2: VersionFilterViewT2Model,
    @Inject(MAT_DIALOG_DATA) public resultViewDataT3: VersionFilterViewT3Model,
    public dialog: MatDialog
  ) {
    this.myInnerHeight = window.innerHeight - 350;
    if (resultViewDataT2 && resultViewDataT2.templateId == 2) {
      this.selfAssessmentT2 = resultViewDataT2.selfAssessment;
      this.templateNo = 2;
    } else if (resultViewData && resultViewData.templateId == 1) {
      this.selfAssessment = resultViewData.selfAssessment;
      this.templateNo = 1;
    } else if (resultViewDataT3 && resultViewDataT3.templateId == 3) {
      this.templateNo = 3;
    }
    this.versionHistory = [];
    this.versionHistoryFilter = new VersionHistoryFilter();
  }

  ngOnInit(): void {
    this.versionHistoryFilter.SortKey = 'Id';
    this.versionHistoryFilter.IsDesc = true;
    this.fetchVersionHistory();
  }

  fetchVersionHistory(): void {
    this.isLoading = true;
    this.versionHistoryFilter.SkipCount = this.skipCount;
    this.versionHistoryFilter.TakeCount = this.takeCount;
    if (this.templateNo == 1) {
      this.versionHistoryFilter.id = this.selfAssessment.id;
      this.gdprService
        .getVersionHistory(this.versionHistoryFilter)
        .subscribe((result: VersionHistoryViewModel) => {
          this.versionHistory = result.data;
          this.totalCount = result.totalCount;
          this.isLoading = false;
          this.endIndex =
            this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        });
    } else if (this.templateNo == 2) {
      this.versionHistoryFilter.id = this.selfAssessmentT2.id;
      this.gdprService
        .getVersionHistoryT2(this.versionHistoryFilter)
        .subscribe((result: VersionHistoryViewModel) => {
          this.versionHistory = result.data;
          this.totalCount = result.totalCount;
          this.isLoading = false;
          this.endIndex =
            this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        });
    } else if (this.templateNo == 3) {
      this.selfAssessmentTemplate3VersionHistoryList();
    }
  }
  selfAssessmentTemplate3VersionHistoryList() {
    if (this.resultViewDataT3.versionType == 'overall') {
      this.overAllAssessmentVersionHistoryList();
    } else if (this.resultViewDataT3.versionType == 'Interpretation') {
      this.interpretationVersionHistoryList();
    } else if (this.resultViewDataT3.versionType == 'Judgement') {
      this.judgementVersionHistoryList();
    } else {
      this.approachVersionHistoryList();
    }
  }
  approachVersionHistoryList(){
    this.versionHistoryFilter.id = this.resultViewDataT3.interpretationId;
    this.selfAssessmentT3Service
      .getapproachVersionHistoryT3(this.versionHistoryFilter)
      .subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
  }
  judgementVersionHistoryList(){
    this.versionHistoryFilter.id = this.resultViewDataT3.interpretationId;
    this.selfAssessmentT3Service
      .getjudgementVersionHistoryT3(this.versionHistoryFilter)
      .subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
  }
  interpretationVersionHistoryList(){
    this.versionHistoryFilter.id = this.resultViewDataT3.interpretationId;
    this.selfAssessmentT3Service
      .getInterpretationVersionHistoryT3(this.versionHistoryFilter)
      .subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
  }
  overAllAssessmentVersionHistoryList(){
    this.versionHistoryFilter.id = this.resultViewDataT3.overallAssessmentId;
    this.selfAssessmentT3Service
      .getOverallVersionHistoryT3(this.versionHistoryFilter)
      .subscribe((result: VersionHistoryViewModel) => {
        this.versionHistory = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
  }
  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  sortVersionHistory(key: string): void {
    this.versionHistoryFilter.IsDesc = !this.versionHistoryFilter.IsDesc;
    this.versionHistoryFilter.SortKey = key;
    this.fetchVersionHistory();
  }
  viewVersionHistory(versionType: string, id: number, versionNo: number) {
    if (versionType == 'overall') {
      const dialogRef = this.dialog.open(
        SelfAssessmentTemplate3OverallAssessmentComponent,
        {
          data: {
            isVersonHistory: true,
            overAssessmentId: id,
            summarydetailsId: this.resultViewDataT3.summuryDetailsId,
            versionNo: versionNo,
          },
          width: '70vw',
          panelClass: 'versionDetails_modal',
        }
      );
    } else if (versionType == 'Interpretation') {
      const dialogRef = this.dialog.open(InterpretationsT3Component, {
        data: {
          isVersonHistory: true,
          overAssessmentId: id,
          summarydetailsId: this.resultViewDataT3.summuryDetailsId,
          versionNo: versionNo,
          tab: this.resultViewDataT3.tab
        },
        width: '70vw',
        panelClass: 'versionDetails_modal',
      });
    } else if (versionType == 'Judgement') {
      const dialogRef = this.dialog.open(JudgmentT3Component, {
        data: {
          isVersonHistory: true,
          overAssessmentId: id,
          summarydetailsId: this.resultViewDataT3.summuryDetailsId,
          versionNo: versionNo,
          tab: this.resultViewDataT3.tab
        },
        width: '70vw',
        panelClass: 'versionDetails_modal',
      });
    } else {
      const dialogRef = this.dialog.open(ApproachT3Component, {
        data: {
          isVersonHistory: true,
          overAssessmentId: id,
          summarydetailsId: this.resultViewDataT3.summuryDetailsId,
          versionNo: versionNo,
          tab: this.resultViewDataT3.tab
        },
        width: '70vw',
        panelClass: 'versionDetails_modal',
      });
    }
  }
}
